var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"promo-image",on:{"click":_vm.goToPromo}},[_c('img',{attrs:{"src":require("../../../assets/images/pp_postnew.png"),"alt":"点击跳转"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }